import { render } from "./NumberedMenuSection.vue?vue&type=template&id=7696b65d"
import script from "./NumberedMenuSection.vue?vue&type=script&lang=js"
export * from "./NumberedMenuSection.vue?vue&type=script&lang=js"

import "./NumberedMenuSection.vue?vue&type=style&index=0&id=7696b65d&lang=css"
script.render = render

export default script